import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import {
    GridRowModes,
    DataGrid,
    GridToolbarContainer,
    GridActionsCellItem,
    GridRowEditStopReasons,
    GridEditInputCell
} from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';

import { Autocomplete, TextField } from "@mui/material";


const Component = forwardRef((props, ref) => {
    const [isReadOnly, setIsReadOnly] = React.useState(props.isReadOnly ?? false);
    const [isexpense, setIsexpense] = React.useState(props.isexpense ?? false);
    const [items, setItems] = React.useState(props.items ? [...props.items] : []);
    const [rows, setRows] = React.useState([...props.Row.bills]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    useEffect(() => {

        props.Row.bills = rows;

        props.updateparent?.apply(this, [rows]);

    }, [rows]);
    useEffect(() => {
        if (props.Row.bills != rows)
            setRows([...props.Row.bills]);
    }, [props.Row.bills]);

    useEffect(() => {
        setIsReadOnly(props.isReadOnly ?? false);
    }, [props.isReadOnly]);

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleDeleteClick = (id) => () => {
        setRows(rows.filter((row) => row.id !== id));
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow) => {
        if (!newRow.qty)
            newRow.qty =1
        newRow.totalamount = newRow.amount * newRow.qty;
        newRow.vatamount = !newRow.vat ? 0 : newRow.amount * newRow.qty * newRow.vat / 100;
        newRow.whtamount = !newRow.wht ? 0 : newRow.amount * newRow.qty * newRow.wht / 100;
        const updatedRow = { ...newRow, isNew: false };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const setItem = (event, newValue, params) => {
       
        if(params.row?.isaddheader){
             params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue })
        }
        else{
        if (!newValue?.text) {
            params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue })
            params.api.setEditCellValue({ id: params.id, field: "value", value: 0 })
            params.api.setEditCellValue({ id: params.id, field: "text", value: null})

        }
        else {
            params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue.text })
            params.api.setEditCellValue({ id: params.id, field: "text", value: newValue.text })
            params.api.setEditCellValue({ id: params.id, field: "value", value: newValue.value })
            params.api.setEditCellValue({ id: params.id, field: "qty", value: newValue.qty })
            params.api.setEditCellValue({ id: params.id, field: "amount", value: newValue.amount })
            params.api.setEditCellValue({ id: params.id, field: "vat", value: newValue.vat })
            params.api.setEditCellValue({ id: params.id, field: "isbillitem", value: newValue.isbillitem })
            params.api.setEditCellValue({ id: params.id, field: "wht", value: newValue.wht })
        }
    }
    }
    const preventEnter =(event)=>{

        if(event.key =="Enter"){
        event.stopPropagation();
        }
    }

    const columns = [
        {
            sortable: true,
            field: 'rownum',
            headerName: '#',
            display: 'flex',
            flex: 0,
            editable: false,
            width: 50,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1

        },
        {
            field: 'value',
            headerName: 'billitemid',
              display: 'flex',
            editable: true,
            hide: true,
        },
        {
            field: 'text',
            headerName: 'billitem',
              display: 'flex',
            editable: true,
            hide: true,
        },
        {
            field: 'rowid',
            headerName: 'rowid',
              display: 'flex',
            editable: true,
            hide: true,
        },
        {
            field: 'item',
            headerName: 'รายการ',
              display: 'flex',
            flex: 1,
            editable: true,
            renderEditCell: (params) => (<Autocomplete
                fullWidth
                freeSolo
                defaultValue={items.find((role) => role.text === params.value) || params.value}
                onKeyDown={(event, newValue) =>preventEnter(event)}
                onKeyUp={(event, newValue) => setItem(event, event.target.value, params)}
                onChange={(event, newValue) => setItem(event, newValue, params)}
                getOptionLabel={(option) => (typeof option === "string" ? option : option.text)}
                options={items}
                renderInput={(params) => <TextField {...params} multiline={true} minRows={2}  />}
            />),

        },
        {
            field: 'qty',
            headerName: 'จำนวน',
            type: 'number',
            display: 'flex',
            width: 150,
            editable: true,
            renderEditCell: (params) => (
                <GridEditInputCell
                    {...params}
                    inputProps={{
                        min: 1,
                    }}
                />
            ),

        },
        {
            field: 'amount',
            headerName: 'ราคา',
            display: 'flex',
            type: 'number',
            width: 110,
            editable: true,
            renderEditCell: (params) => (
                <GridEditInputCell
                    {...params}
                    inputProps={{
                        min: 0,
                    }}
                />
            ),
            valueFormatter: (value) => {
                return value ? new Intl.NumberFormat("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value) : "";
            },
        },
        {
            field: 'vat',
            headerName: 'VAT',
            display: 'flex',
            headerAlign: 'center',
            width: 50,
            editable: true,

        },

        {
            field: 'totalamount',
            headerName: 'มูลค่าก่อนภาษี',
            type: 'number',
            width: 110,
            display: 'flex',
            editable: false,
            valueGetter: (value, row) => {
                row.totalamount = row.amount * row.qty;
                return row.totalamount;
            },
            valueFormatter: (value) => {
                return value ? new Intl.NumberFormat("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value) : "";
            },
        },
        {
            field: 'vatamount',
            headerName: 'VAT',
            type: 'number',
            width: 110,
            display: 'flex',
            editable: false,
            valueGetter: (value, row) => {
                row.vatamount = !row.vat ? 0 : row.amount * row.qty * row.vat / 100;
                return row.vatamount;
            },
            valueFormatter: (value, row) => {
                return value ? new Intl.NumberFormat("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value) : "ไม่มี";
            },
        },
        {
            field: 'wht',
            headerName: 'WHT%',
            
            type: 'number',

            width: 80,
            editable: true,
            renderEditCell: (params) => (
                <GridEditInputCell
                    {...params}
                    inputProps={{
                        min: 0,
                    }}
                />
            ),

        },
        {
            field: 'whtamount',
            headerName: 'WHT',
              display: 'flex',
            type: 'number',
            width: 110,
            editable: false,
            valueGetter: (value, row) => {
                row.whtamount = !row.wht ? 0 : row.amount * row.qty * row.wht / 100;
                return row.whtamount;
            },
            valueFormatter: (value, row) => {
                return value ? new Intl.NumberFormat("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value) : "";
            },
        },
        {
            field: 'discount',
            headerName: 'ส่วนลด',
              display: 'flex',
            type: 'number',
            width: 110,
            editable: true,
            hide: !isexpense,
            renderEditCell: (params) => (
                <GridEditInputCell
                    {...params}
                    inputProps={{
                        min: 0,
                    }}
                />
            ),
            valueFormatter: (value) => {
                return value ? new Intl.NumberFormat("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value) : "";
            },
        },
        {
            field: 'isbillitem',
            headerName: 'เรียกเก็บ',
            headerAlign: 'center',
              display: 'flex',
            width: 80,
            editable: true,
            align: 'center',
            type: 'boolean',
        },
        {
            field: 'actions',
            type: 'actions',
              display: 'flex',
            headerName: '',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
            
                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }
                
                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        disabled={isReadOnly}
                        onClick={!isReadOnly&&handleEditClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        disabled={isReadOnly}
                        onClick={!isReadOnly&&handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },


    ];

    function EditToolbar(props1) {
        const { setRows, setRowModesModel } = props1;

        const handleClick = () => {
            const id = uuidv4();
            setRows((oldRows) => [
                ...oldRows,
                { id, transport_listid: props.Row.id, isNew: true, qty: 1 },
            ]);
            setRowModesModel((oldModel) => ({
                ...oldModel,
                [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
            }));
        };

        return (
            <GridToolbarContainer>
                {!isReadOnly &&<Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    เพิ่มรายการ
                </Button>}
            </GridToolbarContainer>
        );
    }

    return (<>

        <DataGrid key={props.index}
        getRowHeight={() => 'auto'} 
            rows={rows}
            columns={columns}
            disableColumnMenu
            editMode="row"
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            slots={{ toolbar: EditToolbar }}
            slotProps={{
                toolbar: { setRows, setRowModesModel },
            }}
            isCellEditable={(params) => {
                if(isReadOnly) return false;
                return true;
                if (params.field == "item" && params.row.isaddheader === 1) return false;
                else return true;

            }}

            columnVisibilityModel={{

               
                vat: false,
                value: false,
                rowid: false,
                text: false,
                discount: isexpense,
                isbillitem: !isexpense

            }}

            hideFooter
        />

    </>

    );
});



export default Component;